import { useCallback } from 'react';

type AsyncFunction<T> = () => Promise<T>;

export function useCallbackReduxAsyncThunkRetry<T>(
  asyncFunction: AsyncFunction<T>,
  maxRetries: number = 3,
  delayMs: number = 500
): UseAsyncRetryResult<T> {
  const execute = useCallback((...params: any) => {
    const attemptFetch = async (currentAttempt: number) => {
      try {
        const result = await asyncFunction(...params);

        if (result.payload.error) {
          if (currentAttempt < maxRetries) {
            setTimeout(() => attemptFetch(currentAttempt + 1), delayMs);
          } else {
            return result;
          }
        } else {
          return result;
        }
      } catch (e) {
        return e;
      }
    };

    return attemptFetch(1);
  }, [asyncFunction, maxRetries, delayMs]);

  return execute;
}
